import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { IconFeatureCard } from '@src/components/promoCards/layouts/OneThird/Training';
import { featureCards } from '@src/global/traingAndJobAidsData';


export const SelectionCards = () => {
    return (
        <Row className="selection-card-row main-container-row">
            {
                featureCards.map((featureCard) => {
                    return (
                        <Col key={featureCard.title} xs={12} md={4} className="selection-card-container">
                            <IconFeatureCard {...featureCard} />
                        </Col>
                    );
                })
            }
        </Row>
    );
};

export default SelectionCards;
